import {createUseStyles} from 'react-jss';
export default createUseStyles({
  container: {
    display: 'flex',
    width: '100%',
    minHeight: '100vh',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: "column",
    '& h4': {
      fontWeight: '300',
      marginBottom: 10
    },
    '& h1': {
      fontWeight: '400'
    }
  },
  loading: {
    minHeight: '100vh'
  }
})